import React, { Attributes, HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLButtonElement> {}

const ModalCloseBtn = (props: Props) => {
  return (
    <button className="modal-close-btn" {...props}>
      {Icon}
    </button>
  );
};

export default ModalCloseBtn;

const Icon = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="11.5px" height="11.5px" viewBox="-36.5 91.5 648.5 684.99" >
    <polygon
      className="icon-fill"
      points="356.28,433.98 599.55,167.05 611.11,154.38 599,142.22 562.78,105.85 549.45,92.47 536.72,106.43 287.76,379.61 38.77,106.43 26.04,92.46 12.71,105.86 -23.51,142.26 -35.61,154.41 -24.06,167.08 219.22,434.01 -24.05,700.94 -35.61,713.61 -23.5,725.76 12.72,762.13 26.05,775.52 38.78,761.56 287.74,488.38 536.73,761.56 549.46,775.53 562.79,762.13 599.01,725.73 611.11,713.58 599.56,700.91 "
    />
  </svg>
);
